export const routerLottery = [
    {
        path: '/lottery/list',
        name: 'LotteryList',
        meta: {
            authRequired: true,
            roleDefault: '',
            role: ['lottery.view'],
            typeRouterForm: false,
            titleJP: '抽選一覧',
            pageNames: [
                {
                    text: 'ダッシュボード',
                    href: '/'
                },
                {
                    text: '抽選一覧',
                    active: true
                }
            ]
        },
        component: () => import('@/views/pages/lottery/list/main.vue')
    },
    {
        path: '/lottery/create',
        name: 'LotteryCreate',
        meta: {
            authRequired: true,
            roleDefault: '',
            role: ['lottery.register'],
            typeRouterForm: true,
            titleJPAdd: '抽選新規登録',
            pageNamesAdd: [
                {
                    text: 'ダッシュボード',
                    href: '/'
                },
                {
                    text: '抽選新規登録',
                    active: true
                }
            ]
        },
        component: () => import('@/views/pages/lottery/create/main.vue')
    },
    {
        path: '/lottery/edit',
        name: 'LotteryEdit',
        meta: {
            authRequired: true,
            roleDefault: '',
            role: ['lottery.edit'],
            typeRouterForm: true,
            titleJPEdit: '抽選 編集',
            pageNamesEdit: [
                {
                    text: 'ダッシュボード',
                    href: '/'
                },
                {
                    text: '抽選一覧',
                    href: '/lottery/list'
                },
                {
                    text: '抽選 編集',
                    active: true
                }
            ]
        },
        component: () => import('@/views/pages/lottery/edit/main.vue')
    }
];
